"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get LogLevel () {
        return _LogLevel.LogLevel;
    },
    get Logger () {
        return _Logger.Logger;
    },
    get default () {
        return createLogger;
    }
});
const _Logger = require("./Logger.js");
const _LogLevel = require("./interfaces/LogLevel.js");
function createLogger() {
    return new _Logger.Logger();
}
